import React from 'react';
import { FormattedMessage } from 'react-intl';
import { StyledH2 } from 'pages/QuoteConfirmation/styles';

const ReviewQuoteFooter = () => (
  <>
    <StyledH2>
      <FormattedMessage id="quoteConfirmation.copy.importantInformation" />
    </StyledH2>
    <p>
      <FormattedMessage id="reviewQuote.staticFooterOne" />
    </p>
    <p>
      <FormattedMessage id="reviewQuote.staticFooterTwo" />
    </p>
    <br />
    <b>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.groupSalesExecutive" />
      </p>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.telNumber" />
      </p>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.address" />
      </p>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.website" />
      </p>
    </b>
  </>
);

export default ReviewQuoteFooter;
